import http from '@/biz/http.mjs'
import metaBizNode from '../../metaBizNode.mjs'
import parseMap from '../../scripts/parseMap.mjs'

export default ({bizNodeType, mode, pkid, prjPatternId, rev}) => {
    return async () => {
        const [url, mapProp] = (() => {
            if (prjPatternId) {
                return [
                    `/patterns/${mode[0].toLowerCase()}${mode.slice(1)}`,
                    'map'
                ]
            }
            else if ('BdReferenceCall' === mode) {
                return ['/moduleReference/bdReferencecall', 'map']
            }
            else if ('DtReferenceCall' === mode) {
                return ['/moduleReference/dtReferencecall', 'map']
            }
            else if ('MDM' === bizNodeType) {
                return [`/mdModules/${mode.toLowerCase()}`, 'map']
            }
            else if (/^(ChgReferenceSingle|Reference|ReferenceCall)$/.test(mode)) {
                return [`/moduleReference/${mode.toLowerCase()}`, 'map']
            }
            else {
                const {mapProp} = metaBizNode[bizNodeType]
                const m = mode.toLowerCase()

                const url = (() => {
                    if ('AD' == bizNodeType) {
                        return `/amao/${m}`
                    }
                    else if ('AIAC' == bizNodeType) {
                        return `/amAi/${m}`
                    }
                    else if ('ARRD' == bizNodeType) {
                        return `/amAr/rd/${m}`
                    }
                    else if ('ARRI' == bizNodeType) {
                        return `/amAr/ri/${m}`
                    }
                    else if (/^BD(ALG|BASE|SUMMARY)$/.test(bizNodeType)) {
                        return `/dmbds/${m}`
                    }
                    else if ('BDEVENT' === bizNodeType) {
                        return `/dmbds/event/${m}`
                    }
                    else if (/^BD(LOGIC|RULE)$/.test(bizNodeType)) {
                        if ('ApiEffect' === mode) {
                            return '/dmdts/apiEffect'
                        }
                        else if ('DeDepend' === mode) {
                            return '/dmbds/rule/deDepend'
                        }
                        else if ('DtDepend' === mode) {
                            return '/dmbds/rule/dtDepend'
                        }
                        else {
                            return `/dmbds/rule/${m}`
                        }
                    }
                    else if ('BFDATAFLOW' === bizNodeType) {
                        return `/bmbfs/${m}`
                    }
                    else if ('DE' == bizNodeType) {
                        return `/amdo/${m}`
                    }
                    else if ('DT' === bizNodeType) {
                        if ('ApiEffect' === mode) {
                            return '/dmdts/apiEffect'
                        }
                        else if ('Effect' === mode) {
                            return '/dmdts/effect'
                        }
                        else if ('FkDepend' === mode) {
                            return '/dmdts/fk/depend'
                        }
                        else if ('FkEffect' === mode) {
                            return '/dmdts/fk/effect'
                        }
                    }
                    else if ('DV' == bizNodeType) {
                        return `/dmdvs/${m}`
                    }
                    else if ('LSI' == bizNodeType) {
                        return `/imlsis/${m}`
                    }
                    else if ('SF' === bizNodeType) {
                        return `/rmsfs/${m}`
                    }
                    else if ('UE' == bizNodeType) {
                        return `/umuis/ue/${m}`
                    }
                    else if ('UI' === bizNodeType) {
                        if ('CallUiDepend' === mode) {
                            return '/umuis/ui/depend'
                        }
                        else if ('CallUiEffect' === mode) {
                            return '/umuis/ui/effect'
                        }
                        else {
                            return `/umuis/${m}`
                        }
                    }
                    else if ('UIALG' === bizNodeType) {
                        return `/umuis/alg/${m}`
                    }
                    else if ('UIRULE' === bizNodeType) {
                        return `/umuis/rule/${m}`
                    }
                })()

                if (
                    'ApiEffect' === mode &&
                    'BDRULE' === bizNodeType
                ) {
                    return [url, 'dtMap']
                }
                else {
                    return [url, mapProp]
                }
            }
        })()

        const {[mapProp]: mapData} = await http.post(
            url, {pkid, bizNodeType, rev, prjPatternId}
        )

        return parseMap(mapData)
    }
}
